export default Object.freeze({
    ACCOUNT_FOUND: 'account_found',
    LOGIN_ERROR: 'login_error',
    REGISTER_ERROR: 'register_error',
});



// WEBPACK FOOTER //
// ./src/Assets/components/Users/LoginOrSignup/consts/alert_types.js